import API from "./axios";

export class OrdersService {
    getOrdersList(pageNumber: number, size: number, entId: number, approvalStatus: number): Promise<any> {
        return API.post(`api/index.php`, { action: 'getOrdersList', src: 'dashboard', retrievalmode: 'mysql' ,'entId':entId,'approvalStatus':approvalStatus});
    }

    getQuoteList(pageNumber: number, size: number, entId: number): Promise<any> {
        return API.post(`api/index.php`, { action: 'getQuotesList', src: 'dashboard', retrievalmode: 'mysql' ,'entId':entId});
    }

    

    getQuoteDetails(  entId: number, orderId: number): Promise<any> {
        return API.post(`api/index.php`, { action: 'getSavedQuoteData', src: 'dashboard', retrievalmode: 'mysql' ,'entId':entId,'Id':'///'+orderId});
    }

    getOrderDetails(  entId: number, orderId: number): Promise<any> {
        return API.post(`api/index.php`, { action: 'getSavedOrderData', src: 'dashboard', retrievalmode: 'mysql' ,'entId':entId,'Id':'///'+orderId});
    }

    convertQuoteToOrder(   entId:any,quoteId:any,transportname:string): Promise<any> {
        return API.post(`api/index.php`, { action: 'convertQuoteToOrder', src: 'dashboard', retrievalmode: 'mysql' ,'entId':entId,'Id':'///'+quoteId , transportname:transportname});
    }

   // {"action":"convertQuoteToOrder",entId:entId,Id:Id,nName:nName,transportname:transportname,userid:userid}

    setOrderStatus(orderId: number,approvalStatus:number, oin:string): Promise<any> {
       // console.log('OIN: '+ oin +',orderId: '+orderId +',approvalStatus : '+approvalStatus);
        return API.post(`api/index.php`, { action: 'setOrderApprovalStatus', src: 'dashboard', retrievalmode: 'mysql' ,'Id':orderId,'approvalStatus':approvalStatus,'oin':oin});
    }


    downloadPdf(entId: number, orderId: number): Promise<any> {
        // this one send file as Blob type 

        return API.post(`GeneratePDF/OrderToPDF.php`, { entId: entId, Id: orderId },
            {
                responseType: 'blob',
                headers: {
                    Accept: 'application/octet-stream',
                },
            })

    }

    downloadExcel(entId: number, orderId: number): Promise<any> {
        // this one send file as Blob type 

        return API.post(`GenerateExcel/OrderToExcel.php`, { entId: entId, Id: orderId },
            {
                responseType: 'blob',
                headers: {
                    Accept: 'application/octet-stream',
                },
            })

    }

    // quote apis

    downloadQuotationPdf(entId: number, orderId: number): Promise<any> {
        // this one send file as Blob type 

        return API.post(`GeneratePDF/QuoteToPDF.php`, { entId: entId, Id: orderId },
            {
                responseType: 'blob',
                headers: {
                    Accept: 'application/octet-stream',
                },
            })

    }

    downloadQuotationExcel(entId: number, orderId: number): Promise<any> {
        // this one send file as Blob type 

        return API.post(`GenerateExcel/QuoteToExcel.php`, { entId: entId, Id: orderId },
            {
                responseType: 'blob',
                headers: {
                    Accept: 'application/octet-stream',
                },
            })

    }


    
}